<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="操作验证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">手机号码：</div>
          <Input
            class="height45"
            v-model="user.phoneNumber"
            disabled
            placeholder="请输入手机号码"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">验证码：</div>
          <div class="row">
            <Input
              class="height45"
              v-model="form.code"
              @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
              placeholder="请输入验证码"
              style="width: 120px"
              clearable
            />
            <smsBtn
              ref="smsBtn"
              height="45px"
              shape=""
              @tap="getCodeEvent"
              style="width: 120px; margin-left: 30px"
            ></smsBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { smsSend } from "api/customer.js";
import { mapMutations, mapState } from "vuex";
import loading from "components/loading.vue";
import smsBtn from "components/smsBtn.vue";
export default {
  name: "autoRenewModal",
  components: {
    loading,
    smsBtn,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        code: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    // 取消
    onCancel() {
      this.form = this.$options.data().form;
      this.$refs.smsBtn.reset();
      this.visibility = false;
    },
    // 获取验证码
    getCodeEvent(callback) {
      smsSend()
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 确认
    async onConfirm() {
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      this.loading = true;
      this.$emit("confirm", this.form.code, (res) => {
        if (res) {
          this.loading = false;
          this.$refs.smsBtn.reset();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.row {
  display: flex;
  align-items: center;
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
